import { CommandBar, ICommandBarItemProps, Icon, SearchBox, TooltipHost } from "@fluentui/react"
import { RegionComponent } from "./componentes/RegionComponent"
import { UseEstadoEquipo } from "./useEstadoEquipo"
import { SpinnerTable } from "../../../components/spinner/spinnerTable"
import { PanelFiltroEstadoEquipo } from "./PanelFiltroEquipo/PanelFiltroEstadoEquipo"
import { CabeceraTable } from "../../../components/Table/CabeceraTable";
import themeBase from "../../../utils/theme/themeBase";
import IconHelper from "../../../utils/helpers/iconHelper";
import { useState } from "react";
import { useBoolean } from "@fluentui/react-hooks";
import { PanelEquipoSync } from "./PanelSync/PanelSyncEquipo"

export const EstadoEquipo = () => {
  const { loading, items, getEstadoEquipos, handleResetUpdate, filter, setFilter, onChangeSearch, _onkeyUpSearchTable, buscar, resetFilter2, onChangeComboFilter, filter2 ,onChangeComboFilterMultiple} = UseEstadoEquipo()
  const [openFiltraraEstadoE, setOpenEstadoEquipo] = useState(false)
  const [isOpenSYNC, { setTrue: openPanelSYNC, setFalse: closePanelSYNC }] = useBoolean(false);

  const buttonLeft: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_RELOAD,
      text: "Actualizar",
      onClick: () => {
        handleResetUpdate()
        getEstadoEquipos()
      },
    },
    {
      ...IconHelper.ICON_RELOAD2,
      text: "Sincronizar",
      onClick: () => {
        openPanelSYNC()
      },
    },
  ];
  const buttonRight: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_BS_FILTER,
      text: "Buscar",
      onClick: () => {
        setOpenEstadoEquipo(true)
      },
    }
  ];

  return (
    <>
      <CabeceraTable
        Titulo={"Estado de equipos"}
        SubTitulo={"Lista del Estado de Equipos"}
        placeholder="Buscar por Código"
        componentRef={onChangeSearch}
        onKeyUp={_onkeyUpSearchTable}
      />
      <PanelFiltroEstadoEquipo
        filter2={filter2}
        onChangeComboFilterMultiple={onChangeComboFilterMultiple}
        onChangeComboFilter={onChangeComboFilter}
        resetFilter2={resetFilter2}
        buscar={buscar}
        isOpen={openFiltraraEstadoE}
        onDismiss={() => setOpenEstadoEquipo(false)}
      />
      <PanelEquipoSync isOpen={isOpenSYNC} onDismiss={closePanelSYNC } reload={handleResetUpdate}/>

      <div style={{ marginBottom: "20px" }}>
        {(buttonLeft.length > 0 || buttonRight.length > 0) && (
          <div className="ms-Grid-col ms-sm12 ms-lg12">
            <CommandBar
              items={buttonLeft}
              farItems={buttonRight}
              styles={themeBase.commadStyles}
            />
          </div>
        )}
        {loading ? (
          <SpinnerTable />
        ) : (
          <>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: "16px",
                alignItems: "start",
                padding: "15px",
              }}
            >
              {items.map((item, index) => (
                <RegionComponent
                  region={item}
                  key={index}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </>
  );
};

